export default "__VITE_ASSET__xPtREuJP__"